import { Component, inject } from '@angular/core'
import { MessageService } from '../../../core/services/message.service'

@Component({
    selector: 'app-no-auction',
    templateUrl: './no-auction.component.html',
    styleUrls: ['./no-auction.component.scss'],
    standalone: false
})
export class NoAuctionComponent {
    readonly messageService = inject(MessageService);
}
